<template>
  <div class="mobile-container">
    <section class="banner-wrapper">
      <div class="content">
        <button class="download-btn" @click="scrollToDownload"></button>
      </div>
      <div class="banner-left-bg" style="background: #0e1361;"></div>
      <div class="banner-right-bg" style="background: #0e1361;"></div>
    </section>

    <div class="feature-wrapper">
      <h3 class="title">六大核心功能</h3>

      <div class="features">
        <div class="feature feature-1">
          <div class="feature-title">数百商家</div>
          <div class="feature-minor">商购软件提供数百家优质商家供您选择</div>
        </div>
        <div class="feature feature-2">
          <div class="feature-title">百万商品</div>
          <div class="feature-minor">平台涵盖各种品类几百万种优质商品</div>
        </div>
        <div class="feature feature-3">
          <div class="feature-title">安全密钥</div>
          <div class="feature-minor">每个使用者有一串安全密令保障您的使用安全</div>
        </div>

        <br>

        <div class="feature feature-4">
          <div class="feature-title">每日大促</div>
          <div class="feature-minor">平台不定期开展优惠力度巨大的促销活动</div>
        </div>
        <div class="feature feature-5">
          <div class="feature-title">一键点货</div>
          <div class="feature-minor">经过数次优化的点货流程高效便捷</div>
        </div>
        <div class="feature feature-6">
          <div class="feature-title">订单追踪</div>
          <div class="feature-minor">随时随地查看订单详细信息祝您无忧</div>
        </div>
      </div>
    </div>

    <div class="reason-wrapper">
      <h3 class="title">为什么使用商购</h3>

      <div class="reasons">
        <div class="reason reason-1">
          <div class="reason-title">产品一体化</div>
          <div class="reason-minor">覆盖商贸各个环节的一体化软件服务</div>
        </div>
        <div class="reason reason-2">
          <div class="reason-title">云端同步</div>
          <div class="reason-minor">存储于云端的数据实时更新同步</div>
        </div>
        <div class="reason reason-3">
          <div class="reason-title">数据安全</div>
          <div class="reason-minor">阿里云保障您的数据100%安全可靠</div>
        </div>
        <div class="reason reason-4">
          <div class="reason-title">服务稳定</div>
          <div class="reason-minor">基于阿里云服务的基站平台保障服务的安全和稳定</div>
        </div>
      </div>
    </div>

    <div class="download-wrapper" ref="download">
      <h3 class="title">相关下载</h3>

      <div class="downloads">
        <a class="download download-ios"
           href="https://apps.apple.com/cn/app/%E5%95%86%E8%B4%AD/id1438419878"
           target="_blank"></a>
        <a class="download download-android"
           href="/PMBOX/up/sg-android.apk"
           download="sg-android.apk"
           target="_blank"></a>
        <a class="download download-scan" href="#" @click.prevent=""></a>
      </div>
    </div>

    <div class="footer"></div>
  </div>
</template>

<script>
import preloadImage from 'src/modules/preload-image';

export default {
  created() {
    setTimeout(() => {
      preloadImage(require('./images/download-btn-hover.png'));
      preloadImage(require('./images/download-btn-active.png'));
    }, 100);
  },
  methods: {
    scrollToDownload() {
      const el = this.$refs.download;
      if (el) {
        el.scrollIntoView();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .mobile-container {
    .banner-wrapper {
      position: relative;
      height: 540px;
      background: url("images/banner.png") center no-repeat;

      .banner-left-bg {
        position: absolute;
        top: 0;
        left: 0;
        width: 50%;
        height: 100%;
        z-index: -1;
      }

      .banner-right-bg {
        position: absolute;
        top: 0;
        right: 0;
        width: 50%;
        height: 100%;
        z-index: -1;
      }

      .content {
        width: $content-width;
        margin: 0 auto;
      }

      .download-btn {
        position: absolute;
        bottom: 173px;
        margin-left: 60px;
        width: 180px;
        height: 52px;
        background: url("images/download-btn.png") center no-repeat;
        @include plain-button;

        &:hover {
          background-image: url("images/download-btn-hover.png");
        }

        &:active {
          background-image: url("images/download-btn-active.png");
        }
      }
    }

    .title {
      margin: 0;
      text-align: center;
      color: #2a2a2a;
      font-size: 36px;
      font-weight: lighter;
      letter-spacing: 4px;
    }

    .feature-wrapper {
      .title {
        margin-top: 88px;
      }

      .features {
        margin-top: 15px;
        text-align: center;

        .feature {
          display: inline-block;
          width: 206px;
          height: 340px;
          background-repeat: no-repeat;
          background-position: center top;
          background-color: transparent;
          padding-top: 206px;
          box-sizing: border-box;
          color: #2a2a2a;
          margin-bottom: 10px;

          .feature-title {
            margin-top: 34px;
            font-size: 26px;
          }

          .feature-minor {
            margin-top: 18px;
            line-height: 26px;
            font-size: 16px;
          }

          & + .feature {
            margin-left: 140px;
          }
        }

        .feature-1 {
          background-image: url("images/feature-1.png");
        }

        .feature-2 {
          background-image: url("images/feature-2.png");
        }

        .feature-3 {
          background-image: url("images/feature-3.png");
        }

        .feature-4 {
          background-image: url("images/feature-4.png");
        }

        .feature-5 {
          background-image: url("images/feature-5.png");
        }

        .feature-6 {
          background-image: url("images/feature-6.png");
        }
      }
    }

    .reason-wrapper {
      margin-top: 64px;
      padding-top: 88px;
      padding-bottom: 250px;
      background: #13225d;

      .title {
        color: #ffffff;
      }

      .reasons {
        margin-top: 98px;
        text-align: center;
        color: #ffffff;

        .reason {
          display: inline-block;
          width: 194px;
          height: 228px;
          background-repeat: no-repeat;
          background-position: center top;
          background-color: transparent;
          padding-top: 144px;
          box-sizing: border-box;

          & + .reason {
            margin-left: 80px;
          }

          .reason-title {
            margin-top: 14px;
            font-size: 26px;
          }

          .reason-minor {
            margin-top: 18px;
            line-height: 26px;
            font-size: 16px;
          }

          & + .feature {
            margin-left: 140px;
          }
        }

        .reason-1 {
          background-image: url("images/reason-1.png");
        }

        .reason-2 {
          background-image: url("images/reason-2.png");
        }

        .reason-3 {
          background-image: url("images/reason-3.png");
        }

        .reason-4 {
          background-image: url("images/reason-4.png");
        }
      }
    }

    .download-wrapper {
      background: #f5f5f5;
      padding-top: 88px;

      .downloads {
        padding-top: 66px;
        padding-bottom: 116px;
        text-align: center;

        .download {
          display: inline-block;
          width: 280px;
          height: 280px;
          background-repeat: no-repeat;
          background-position: center top;
          background-color: transparent;
          border-radius: 10px;

          &:hover {
            box-shadow: 1px 1px 10px 0 #9a9a9a;
          }

          & + .download {
            margin-left: 30px;
          }
        }

        .download-ios {
          background-image: url("images/download-ios.png");
        }

        .download-android {
          background-image: url("images/download-android.png");
        }

        .download-scan {
          background-image: url("images/qrcode-mobile.png");
          background-size: 100% 100%;
        }
      }
    }

    .footer {
      height: 215px;
      background: #070c1f;
    }
  }
</style>
